import {
  Accessibility,
  Bed,
  Activity,
  HeartPulse,
  Stethoscope,
  ShowerHead,
} from "lucide-react";


const categories = [
  {
    id: "wheelchairs",
    title: "Wheelchairs",
    icon: Accessibility,
  },
  {
    id: "hospital-beds",
    title: "Hospital Beds",
    icon: Bed,
  },
  {
    id: "walking-aids",
    title: "Walking Aids",
    icon: Activity,
  },
  {
    id: "diagnostic",
    title: "Diagnostic",
    icon: Stethoscope,
  },
  {
    id: "patient-care",
    title: "Patient Care",
    icon: HeartPulse,
  },
  {
    id: "safety",
    title: "Safety",
    icon: ShowerHead,
  },

];


export default categories;